import apiService from "../../ApiService";

export const celcomGenerateToken = (planId: string, redirectUrl?: string) => {
  return apiService.post<{ token: string; url: string }>({
    path: `v1/store/celcom/token`,
    body: { plan: planId, redirectUrl },
  });
};
